/**
 * BHG Design Tokens - Colors
 * 
 * Color tokens extracted from Figma design system.
 * All colors follow the 25-900 shade scale (11 shades per color).
 */

export const colors = {
  // Primary Brand Colors (Blue)
  primary: {
    25: '#F1F8FE',
    50: '#E3F2FD',
    100: '#BBDEFB',
    200: '#90CAF9',
    300: '#64B5F6',
    400: '#42A5F5',
    500: '#2196F3',
    600: '#1E88E5',
    700: '#1976D2',
    800: '#1565C0',
    900: '#0D47A1',
    // Convenience aliases
    light: '#64B5F6',
    base: '#2196F3',
    dark: '#1976D2',
  },

  // Gray Scale
  gray: {
    25: '#FEFEFE',
    50: '#FAFAFA',
    100: '#F5F5F5',
    200: '#EEEEEE',
    300: '#E0E0E0',
    400: '#BDBDBD',
    500: '#9E9E9E',
    600: '#757575',
    700: '#616161',
    800: '#424242',
    900: '#101828',
    // Convenience aliases
    light: '#EEEEEE',
    base: '#9E9E9E',
    dark: '#101828',
  },

  // Error Colors (Red/Maroon)
  error: {
    25: '#FFF5F5',
    50: '#FFEBEB',
    100: '#FFCDD2',
    200: '#EF9A9A',
    300: '#E57373',
    400: '#EF5350',
    500: '#F44336',
    600: '#E53935',
    700: '#D32F2F',
    800: '#B71C1C',
    900: '#7A092B',
    // Convenience aliases
    light: '#E57373',
    base: '#F44336',
    dark: '#7A092B',
  },

  // Warning Colors (Orange/Brown)
  warning: {
    25: '#FFF8F0',
    50: '#FFF3E0',
    100: '#FFE0B2',
    200: '#FFCC80',
    300: '#FFB74D',
    400: '#FFA726',
    500: '#FF9800',
    600: '#FB8C00',
    700: '#F57C00',
    800: '#E65100',
    900: '#7A2E0E',
    // Convenience aliases
    light: '#FFB74D',
    base: '#FF9800',
    dark: '#7A2E0E',
  },

  // Success Colors (Green)
  success: {
    25: '#F1F8F2',
    50: '#E8F5E9',
    100: '#C8E6C9',
    200: '#A5D6A7',
    300: '#81C784',
    400: '#66BB6A',
    500: '#4CAF50',
    600: '#388E1C',
    700: '#297A13',
    800: '#1B5E0A',
    900: '#145607',
    // Convenience aliases
    light: '#81C784',
    base: '#4CAF50',
    dark: '#145607',
  },

  // Secondary Colors (Orange/Amber)
  secondary: {
    25: '#FFFCF6',
    50: '#FFF8EE',
    100: '#FFF1DC',
    200: '#FFE4BD',
    300: '#FFD699',
    400: '#FFCA7A',
    500: '#FFB74D',
    600: '#C77800',
    700: '#A86A00',
    800: '#8A5A00',
    900: '#6D4C00',
    // Convenience aliases
    light: '#FFD699',
    base: '#FFB74D',
    dark: '#6D4C00',
  },

  // Accent Colors (Teal/Green)
  accent: {
    25: '#F0F9F8',
    50: '#E0F2F1',
    100: '#B2DFDB',
    200: '#80CBC4',
    300: '#4DB6AC',
    400: '#26A69A',
    500: '#009688',
    600: '#00897B',
    700: '#00796B',
    800: '#00695C',
    900: '#004D40',
    // Convenience aliases
    light: '#4DB6AC',
    base: '#009688',
    dark: '#004D40',
  },

  // Base Colors
  base: {
    white: '#FFFFFF',
    black: '#000000',
  },
} as const;
